import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseQuery } from "../baseApi";

export type ShopkeeperStatus = "PENDING" | "ISSUED" | "REJECTED" | "ALL";

export interface ShopkeeperItem {
  Spare_ID: number;
  Notification_UID: string;
  Requested_By: string;
  Requested_Date: string;
  Material_Code: string;
  Material_Name: string;
  Quantity_requested: number;
  Availability: number | null;
  Status: ShopkeeperStatus;
}

export interface ShopkeeperResponse {
  items: ShopkeeperItem[];
  pagination: {
    page: number;
    limit: number;
    totalRecords: number;
    totalPages: number;
  };
}

export interface GetItemsParams {
  status?: ShopkeeperStatus;
  page: number;
  plant: string;
  limit: number;
  search?: string;
  fromDate?: string;
  toDate?: string;
}
export interface ShopkeeperActionPayload {
  spareItemId: number;
  action: "approve" | "reject";
  remarks?: string;
}
export interface ShopkeeperCountResponse {
  count: {
    PENDING: number;
    ISSUED: number;
    REJECTED: number;
    ALL: number;
  };
}



export const shopkeeperApi = createApi({
  reducerPath: "shopkeeperApi",
  baseQuery: createBaseQuery("shopkeeper/"),
  tagTypes: ["ShopkeeperItems", 'ShopkeeperCounts'],
  endpoints: (builder) => ({
    getItems: builder.query<ShopkeeperResponse, GetItemsParams>({
      query: (params) => ({
        url: "items",
        params,
      }),
      providesTags: ["ShopkeeperItems"],
    }),
    getCounts: builder.query<
      ShopkeeperCountResponse,
      { plant: string; fromDate?: string; toDate?: string }
    >({
      query: (params) => ({
        url: "counts", 
        params,
      }),
      providesTags: ["ShopkeeperCounts"],
    }),
    approveRejectItem: builder.mutation<
      { message: string },
      { spareItemId: number; action: "approve" | "reject"; remarks?: string; serialNumber?: string; valuationType?: string }
    >({
      query: ({ spareItemId, action, remarks, serialNumber, valuationType }) => ({
        url: `item/${spareItemId}/${action}`,
        method: "POST",
        body: { remarks , serialNumber, valuationType},
      }),
      invalidatesTags: ["ShopkeeperItems", 'ShopkeeperCounts'],
    }),
    getMaterialAvailability: builder.query<any[], string>({
  query: (material) => `/getmaterialSpareAvailability/${material}`,
}),

  }),
  // }),
});

export const { useGetItemsQuery, useApproveRejectItemMutation , useGetCountsQuery, useLazyGetMaterialAvailabilityQuery} = shopkeeperApi;
